
import { eventBus, EventBusEvents } from "@/eventBus"
import { NotificationType } from "@/enums/NotificationType"

let voucherMixin = {
    methods: {
        validateVoucher: function () {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Apply Automatic voucher",
				data: {
					code: this.$route.query.code
				}
			})
			this.$store
				.dispatch("calcDiscount", this.$route.query.code)
				.then(() => {
					this.$store.dispatch("sendMixpanelEvent", {
						msg: "Voucher Validated",
						data: {
							code: this.$route.query.code
						}
					})
				})
				.catch((e) => {
					eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
						message: e ? e : "Invalid or Expired Voucher",
						type: NotificationType.ERROR
					})
					this.$store.dispatch("sendMixpanelEvent", {
						msg: "Voucher Invalid",
						data: {
							code: this.$route.query.code
						}
					})
				})
		}
    }
    
}

export default voucherMixin